import { getOrderSeatsForShowtime } from './get-order-seats-for-showtime';
export const getOrderSeatCountForShowtime = (showtimeId) => {
    return getOrderSeatsForShowtime(showtimeId).length;
};
